import { HttpClient } from '@/shared/lib/http-client';

export const fetchPaymentSystems = async (companyId, programName = null) => {
  const response = await HttpClient.get('/payment-systems/list', {
    companyId,
    programName,
  });

  return response.data;
};